import { CheckIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export interface StepperItem {
  key: string;
  label: string;
}

export function BookingStepper({
  steps,
  activeIndex,
}: {
  steps: StepperItem[];
  activeIndex: number;
}) {
  return (
    <div data-testid="booking-stepper" className="flex items-center gap-2 sm:gap-3">
      {steps.map((step, i) => {
        const done = i < activeIndex;
        const active = i === activeIndex;
        return (
          <div key={step.key} className="flex items-center gap-2 sm:gap-3">
            {i > 0 && <div className="h-px w-3 flex-none bg-border sm:w-6" />}
            <div className="flex items-center gap-2">
              <div
                className={cn(
                  "grid size-6 place-items-center rounded-full border text-xs font-semibold transition-colors",
                  active && "border-foreground bg-foreground text-background",
                  done && "border-transparent bg-primary/15 text-primary",
                  !active && !done && "border-border text-muted-foreground/60",
                )}
              >
                {done ? <CheckIcon className="size-3.5" weight="bold" /> : i + 1}
              </div>
              <span
                className={cn(
                  "whitespace-nowrap text-[12.5px] transition-colors",
                  active ? "font-semibold text-foreground" : "text-muted-foreground/70",
                  !active && "hidden sm:inline",
                )}
              >
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
